module.exports = __webpack_public_path__ + "static/media/454A9127.053f3d5e.jpg";